<template>
  <div class="main" style="z-index: 100000000000">
    <div class="main-c">
      <div style="margin-left: 80px">
        <!-- v-on:mouseover="changeActive(item)" v-if="index<7" v-on:mouseout="removeActive($event)"--->
        <ul v-for="(item, index) in dataList"   :key="index" v-show="index<(isShow==dataList.length ?  dataList.length:9)">
          <li  @click="toSkip(item)">{{item.text}}</li>
          <li  class="main-l">  </li>
        </ul>
        <el-button type="text" @click="showMore(dataList.length)">{{isShow==dataList.length ? "收起" : "更多>"}}</el-button>
<!--        <span class="oder-show-content" @>{{isShow===dataList.length ? "收起" : "更多"}}</span>-->
      </div>
    </div>

  </div>
</template>

<script>
import BASE from "@/api/base/api_base.js";
export  default {
  data(){
    return{
      show:false,
      delits:[],
      isShow:'',
      dataList:[]
    }
  },
  mounted() {
    this.init();
  },
  methods:{
    toSkip(itme){
      // console.log(itme)
      this.$router.push({path:'/h/mall/type',query:{industryTypeName:itme.text}});
    },
    showMore(index){
      if (this.isShow===index){
        this.isShow=''
      }else{
        this.isShow= index;
      }
    },
    changeActive(item){
      this.show=true;
      console.log(item)
      this.delits=item;
    },
    removeActive(){
      this.show=false;
    },
    init(){
      BASE.getDictionaryResolveToTree({code:"0005"}).then(res =>{
        // console.log(res.data)
        this.dataList=res.data.children;
        // console.log(this.dataList)
      })
    }
  }
}
</script>

<style   lang="scss" scoped>
.main{
  margin-top: 20px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  .main-c{
    border-radius: 20px;
    line-height: 60px;
    ul{
      display:inline-block;
    }
    ul li{
      display:inline-block;
      ont-size: 17px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #2A8EFF;
    }
    ul li:hover{
      cursor:pointer;
    }
    .main-l{
      width: 40px
    }
  }


}


</style>



// WEBPACK FOOTER //
// src/pages/webMall/index/classify.vue